import React from 'react';
import { bool, func } from 'prop-types';
import styled from 'styled-components';

import ButtonLink from 'ravenjs/lib/Button/ButtonLink';
import Typography from 'ravenjs/lib/Typography';
import { stringReplaceWithJSX } from 'ravenjs/utils';

import MESSAGES from 'constants/messages';
import { EXTERNAL_LINKS } from 'constants/app';

const ButtonLinkStyled = styled(ButtonLink)`
    font-family: Favorit;
    font-size: 20px;
    font-weight: 500;
`;

const SignInVideoLinkStyled = styled(Typography)`
    padding: 1rem 0 0 0;
    width: 100%;
    font-size: 20px !important;
    font-weight: 500 !important;
`;

export default function SupportActions({ disabled, onForgotPassword, onTechSupportHelp }) {
    const link = {
        LINK_TEXT: (
            <ButtonLink key="terms" target="_blank" href={EXTERNAL_LINKS.SIGN_IN_VIDEO.LINK_URL}>
                {MESSAGES.LOGIN.SIGN_IN_VIDEO.LINK_TEXT}
            </ButtonLink>
        ),
    };

    return (
        <>
            <ButtonLinkStyled key="password_help" disabled={disabled} onClick={onForgotPassword}>
                {MESSAGES.LOGIN.SUPPORT.FORGOT_USERNAME_OR_PASSWORD}
            </ButtonLinkStyled>
            <SignInVideoLinkStyled>
                {stringReplaceWithJSX(MESSAGES.LOGIN.SIGN_IN_VIDEO.DESCRIPTION, link)}
            </SignInVideoLinkStyled>
        </>
    );
}

SupportActions.propTypes = {
    disabled: bool,
    onForgotPassword: func.isRequired,
    onTechSupportHelp: func.isRequired,
};

SupportActions.defaultProps = {
    disabled: false,
};
